/**
 * *****************************************************
 * Copyright 2020-2021 VMware, Inc.  All rights reserved.
 * ******************************************************
 *
 * @format
 */

import { NgModule } from "@angular/core";
import { ClipboardController } from './clipboard.component';

@NgModule({
   imports: [
   ],
   declarations: [
      ClipboardController
   ],
   exports: [
      ClipboardController
   ]
})
export class ChromeClipboardModule {}